<button mat-icon-button
        (click)="open()"
        [matTooltip]="'KNOWLEDGE.HELP_TOOLTIP' | translate"
        class="help-button">
  <mat-icon class="text-gray-400">help_outline</mat-icon>
</button>
